<template>
  <div class="gj-empty">
    <slot name="img">
      <img src="./empty.png" class="gj-empty--img" />
    </slot>
    <slot name="content">
      <span class="gj-empty--description">{{text}}</span>
    </slot>
  </div>
</template>

<script>
  export default {
    name: "gj-empty",
    props: {
      size: {
        type: String
      },
      text: {
        type: String,
        default: () => ('暂无数据')
      }
    }
  }
</script>

<style lang="scss" scoped>
  .gj-empty {
    text-align: center;
  }
  .gj-empty--img {
    width: 100%;
  }
  .gj-empty--description {
    color: #999999;
    font-size: 13px;
    position: relative;
    top: -10px;
  }
  @media screen and (max-width: 1366px) {
      .gj-empty{
        display: flex;
        flex-direction: column;
        align-items: center;
        img{
          width: 100px;
        }
      }
  }
</style>
